// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__4O2tE","title":"ClientReferral_title__3QkKq","itemText":"ClientReferral_itemText__3GfRB"};